import { SVGProps } from "react";

const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={10}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 5L4.99529 9L13 1"
      stroke="#007AF5"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Check;
